import {
  pgTable,
  uuid,
  text,
  integer,
  jsonb,
  timestamp,
  index,
} from "drizzle-orm/pg-core";

const tz = { withTimezone: true } as const;

/**
 * Outcome Pricing Events — individual outcome measurements for V2 billing.
 *
 * V2 Foundation: schema created now, features built in V2.
 * Tracks individual outcomes (lead generated, appointment booked, deal won)
 * that count toward outcome_contracts fulfillment.
 *
 * Related: outcome_contracts (control plane) tracks the contract definition.
 * This table tracks the individual events within tenant data.
 */
export const outcomePricingEvents = pgTable(
  "outcome_pricing_events",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    eventType: text("event_type").notNull(),
      // "lead_generated" | "appointment_booked" | "deal_won" | "revenue_attributed"
    contactId: uuid("contact_id"),
    dealId: uuid("deal_id"),
    valueCents: integer("value_cents"),
    currency: text("currency").notNull().default("EUR"),
    source: text("source"),
      // Which feature/automation generated this outcome
    metadata: jsonb("metadata").$type<Record<string, unknown>>().default({}),
    createdAt: timestamp("created_at", tz).notNull().defaultNow(),
  },
  (table) => [
    index("idx_outcome_event_tenant").on(
      table.tenantId,
      table.eventType,
      table.createdAt,
    ),
  ],
);
